module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mbnskms1-b541d26d02dbcbb8e4f19aa42f64e422.jpg";